// CSS Modules - component class name: ContactForm__

<template>
  <form :class="$style.container">
    <Button
      v-if="contactBack"
      :text="config.labels.backBtn"
      :class="$style.backBtn"
      @onSimpleClick="handleBackClick"
    />
    <h1 v-if="contactTitle">
      {{ config.labels.contactTitle }} {{ contactTitle }}
    </h1>
    <Columns>
      <FormInput
        v-model.trim="$v.formData.company.$model"
        :label="config.labels.company.label"
        :boldLabel="true"
        :errorMessage="config.labels.company.errorMessage"
        :error="$v.formData.company.$error && $v.$dirty && isSubmitted"
        :originalValue="previousData.company ? previousData.company : null"
        :formSubmitSwitch="formSubmitSwitch"
      />
      <FormInput
        v-model.trim="$v.formData.name.$model"
        :label="config.labels.name.label"
        :boldLabel="true"
        :errorMessage="config.labels.name.errorMessage"
        :error="$v.formData.name.$error && $v.$dirty && isSubmitted"
        :originalValue="previousData.name ? previousData.name : null"
        :formSubmitSwitch="formSubmitSwitch"
      />
    </Columns>
    <Columns>
      <FormInput
        v-model.trim="$v.formData.streetNr.$model"
        :label="config.labels.streetNr.label"
        :boldLabel="true"
        :errorMessage="config.labels.streetNr.errorMessage"
        :error="$v.formData.streetNr.$error && $v.$dirty && isSubmitted"
        :originalValue="previousData.streetNr"
        :formSubmitSwitch="formSubmitSwitch"
      />
      <FormInput
        v-model.trim="$v.formData.zipCity.$model"
        :label="config.labels.zipCity.label"
        :boldLabel="true"
        :errorMessage="config.labels.zipCity.errorMessage"
        :error="$v.formData.zipCity.$error && $v.$dirty && isSubmitted"
        :originalValue="previousData.zipCity"
        :formSubmitSwitch="formSubmitSwitch"
      />
    </Columns>
    <Columns>
      <!--
        Use in FormInput
          :reset="true"
        to create a reset button at the right edge of any form filed.
        Example:
        <FormInput
          v-model.trim="$v.formData.phone.$model"
          :label="config.labels.phone.label"
          :optionalLabel="config.labels.phone.optionLabel"
          :error="false"
          :originalValue="previousData.phone"
          :formSubmitSwitch="formSubmitSwitch"
          :reset="true"
        /-->
      <FormInput
        v-model.trim="$v.formData.phone.$model"
        :label="config.labels.phone.label"
        :optionalLabel="config.labels.phone.optionLabel"
        :error="false"
        :originalValue="previousData.phone"
        :formSubmitSwitch="formSubmitSwitch"
      />
      <FormInput
        v-model.trim="$v.formData.fax.$model"
        :label="config.labels.fax.label"
        :optionalLabel="config.labels.fax.optionLabel"
        :error="false"
        :originalValue="previousData.fax"
        :formSubmitSwitch="formSubmitSwitch"
      />
    </Columns>
    <Columns>
      <FormInput
        v-model.trim="$v.formData.email.$model"
        :label="config.labels.email.label"
        :boldLabel="true"
        :errorMessage="config.labels.email.errorMessage"
        :error="$v.formData.email.$error && $v.$dirty && isSubmitted"
        :originalValue="previousData.email"
        :formSubmitSwitch="formSubmitSwitch"
      />
      <div class="column"></div>
    </Columns>
    <Columns>
      <FormTextarea
        v-model.trim="$v.formData.message.$model"
        :label="config.labels.message.label"
        :errorMessage="config.labels.message.errorMessage"
        :error="$v.formData.message.$error && $v.$dirty && isSubmitted"
        :rows="5"
        :columns="20"
      />
    </Columns>
    <Columns>
      <FormInput
        v-model.trim="$v.formData.fileList.$model"
        type="file"
        :label="config.labels.fileList.label"
        :optionalLabel="config.labels.fileList.optionLabel"
        :noFilesLabel="config.labels.fileList.noFilesLabel"
        :maxFilesReachedLabel="config.labels.fileList.maxFilesReachedLabel"
        :errorMessage="config.labels.fileList.errorMessage"
        :error="false"
        :originalValue="previousData.fileList"
        :formSubmitSwitch="formSubmitSwitch"
        @onFileListChanged="handleFileUpload"
      />
      <div class="column"></div>
    </Columns>
    <Columns>
      <Column class="has-text-right-tablet">
        <Button
          type="submit"
          :text="config.labels.sendBtn"
          :isForm="true"
          @close="handleSubmit"
        />
      </Column>
    </Columns>
    <div :class="$style.serverError" v-if="serverError">
      {{ config.serverErrorMessage }}
    </div>
    <ReCaptcha :executeSwitch="executeSwitch" :submit="submit" />
  </form>
</template>

<script>
import axios from "axios";

import Button from "../Button/Button";
import Column from "../Columns/Column";
import Columns from "../Columns/Columns";
import FormInput from "../FormInput/FormInput";
import FormTextarea from "../FormTextarea/FormTextarea";
import ReCaptcha from "../ReCaptcha/ReCaptcha";

import { ContactFormEnum } from "../../utils/form";
import { validations, initialState } from "./helpers";

export default {
  name: "ContactForm",
  components: {
    ReCaptcha,
    Button,
    FormInput,
    FormTextarea,
    Columns,
    Column
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return initialState;
  },
  validations,
  mounted() {
    const { search } = window.location;
    const params = new URLSearchParams(search);

    this.contactTitle = params.get(ContactFormEnum.contactTitle);
    this.formData.formEmail = params.get(ContactFormEnum.contactEmail);
    this.formData.distributorContact = params.get(ContactFormEnum.contactTitle);
    this.contactBack = params.get(ContactFormEnum.contactBack);
  },
  methods: {
    handleFileUpload(files) {
      this.formData.attachments.attachedFiles = files;
    },
    handleBackClick() {
      window.history.back();
    },
    handleSubmit() {
      this.serverError = false;
      this.$v.$touch();
      this.isSubmitted = true;
      this.formSubmitSwitch = !this.formSubmitSwitch;

      if (!this.$v.$invalid) {
        this.executeSwitch = !this.executeSwitch;
      } else {
        this.previousData = JSON.parse(JSON.stringify(this.formData));
      }
    },
    submit(token) {
      const { thankyouUrl } = this.config;
      const url = window.contactFormUrl;
      const {
        location: { origin: domain, pathname: pageUrl },
        currentLanguage: language,
        currentCountry: country
      } = window;

      axios({
        url,
        method: "post",
        responseType: "json",
        data: {
          ...this.formData,
          token,
          domain,
          pageUrl,
          language,
          country
        }
      })
        .then(response => {
          if (response.status === 200) {
            window.open(thankyouUrl, "_self");
            return;
          }

          throw response.statusText;
        })
        .catch(error => {
          this.serverError = true;
          console.error(error);
        });
    }
  }
};
</script>

<style module lang="scss">
@import "./ContactForm.scss";
</style>
